import React, { useEffect } from "react";
import styled from "styled-components";
// import PrinterController from '../../../controller/PrinterController';

// 테스트 데이터
const example = [
  {
    id: 0,
    name: "주방프린터",
    type: "USB",
  },
  {
    id: 1,
    name: "주방프린터2",
    type: "LAN",
  },
  {
    id: 2,
    name: "주방프린터3",
    type: "SERIAL",
  },
  {
    id: 3,
    name: "주방프린터4",
    type: "USB",
  },
  {
    id: 4,
    name: "주방프린터5",
    type: "LAN",
  },
];

// 테스트 selectList
// value: 실제 등록되는 값 / name: select에 표기되는 이름
const serialUSBList = [
  {
    value: 1,
    name: "1 SEWOO 프린터",
  },
  {
    value: 2,
    name: "2 SEWOO 프린터",
  },
  {
    value: 3,
    name: "3 SEWOO 프린터",
  },
  {
    value: 4,
    name: "4 SEWOO 프린터",
  },
];

const lanPortList = [
  {
    value: "COM1",
    name: "COM1",
  },
  {
    value: "COM2",
    name: "COM2",
  },
  {
    value: "COM3",
    name: "COM3",
  },
  {
    value: "COM4",
    name: "COM4",
  },
];

const lanBandRouteList = [
  {
    value: 9600,
    name: "9600",
  },
  {
    value: 14400,
    name: "14400",
  },
  {
    value: 19200,
    name: "19200",
  },
  {
    value: 38400,
    name: "38400",
  },
];

type SelectType = {
  options: any;
  defaultValue: any;
  onChangeValue: any;
};

const Ic_arrow_arrow_left = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 8L12 16L20 24"
        stroke="#6D6D6D"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const Ic_plus = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 4.16602V15.8327M4.16666 9.99935H15.8333"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const Ic_arrow_down = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 7.5L10 12.5L15 7.5"
        stroke="#6D6D6D"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

// custom select
const RenderCustomSelect = ({
  options,
  defaultValue,
  onChangeValue,
}: SelectType) => {
  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  const [selectedOption, setSelectedOption] = React.useState<any>(defaultValue);

  const handleSelectClick = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option: any) => {
    setSelectedOption(option);
    onChangeValue(option);
    setIsOpen(false);
  };

  const getOptionName = () => {
    if (options.find((option: any) => option.value === selectedOption))
      return options.find((option: any) => option.value === selectedOption)
        .name;
    else {
      return "";
    }
  };

  // custom dropdown
  return (
    <div className="selector">
      <div className="selectHeader" onClick={handleSelectClick}>
        {getOptionName()}
        <Ic_arrow_down />
      </div>
      {isOpen && (
        <ul className="selectList">
          {options.map((option: any) => (
            <li
              key={option.value}
              onClick={() => handleOptionClick(option.value)}
              className={`selectItem ${
                option.value === selectedOption && "selected"
              }`}
            >
              {option.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export const PrinterSettings = (oProps: any) => {
  const [printerType, setPrinterType] = React.useState("serial");
  const [sCurrentPage, set_sCurrentPage] = React.useState("list");

  const [printerName, setPrinterName] = React.useState("");
  const [printCount, setPrintCount] = React.useState(0);
  const [serialUsb, setSerialUsb] = React.useState(serialUSBList[0].value);
  const [usbIp, setUsbIp] = React.useState(0);
  const [usbPort, setUsbPort] = React.useState(0);
  const [lanPort, setLanPort] = React.useState(lanPortList[0].value);
  const [lanBandRoute, setLanBandRoute] = React.useState(
    lanBandRouteList[0].value
  );

  const onChange_printerName = (e: any) => {
    setPrinterName(e.target.value);
  };
  const onChange_serialUsb = (e: any) => {
    setSerialUsb(e);
  };
  const onChange_usbIp = (e: any) => {
    setUsbIp(e.target.value);
  };
  const onChange_usbPort = (e: any) => {
    setUsbPort(e.target.value);
  };
  const onChange_lanPort = (e: any) => {
    setLanPort(e.target.value);
  };
  const onChange_lanPort_select = (e: any) => {
    setLanPort(e);
  };
  const onChange_lanBandRoute = (e: any) => {
    setLanBandRoute(e);
  };

  // 프린트 횟수 증감
  const onChange_count = (value: number) => {
    if (value < 0) setPrintCount(0);
    else setPrintCount(value);
  };

  return (
    <Style>
      {/* <div
        className="bgWrapper"
        onClick={() => {
          oProps.showPrinterModal(false);
        }}
      ></div> */}

      {/* 프린터 목록 */}
      <div className="printerWrapper">
        <div className="printerList">
          {sCurrentPage === "list" && (
            <div>
              <div className="row title" onClick={() => { oProps.showPrinterModal(false); }}>
                <Ic_arrow_arrow_left />
                {/* 종료 함수 들어가는 위치 */}
                <h2>프린터 목록</h2>
              </div>
              {/* <button
                onClick={() => {
                  set_sCurrentPage("add");
                }}
              >
                프린터 추가
              </button> */}

              <div className="printerScroll">
                {example.map((item: any, index: number) => {
                  return (
                    <div className="printerItem">
                      <div className="indexBox">{index + 1}</div>
                      <div className="name">{item.name}</div>
                      <button>수정</button>
                      <button>삭제</button>
                      <button className="test">프린터 테스트하기</button>
                    </div>
                  );
                })}
              </div>
              {/* <button
                onClick={() => {
                  oProps.showPrinterModal(false);
                }}
              >
                닫기
              </button> */}
              <div className="footer">
                <button
                  className="submitButton"
                  onClick={() => {
                    set_sCurrentPage("add");
                  }}
                >
                  <Ic_plus />
                  프린터 추가
                </button>
              </div>
            </div>
          )}

          {/* 프린터 추가 */}
          {sCurrentPage === "add" && (
            <div>
              <div
                className="row title"
                onClick={() => set_sCurrentPage("list")}
              >
                <Ic_arrow_arrow_left />
                <h2>프린터 추가</h2>
              </div>

              <div className={"mainTabList"}>
                <div
                  className={`tab ${printerType === "serial" && "active"}`}
                  onClick={() => setPrinterType("serial")}
                >
                  시리얼 프린터
                </div>
                <div
                  className={`tab ${printerType === "usb" && "active"}`}
                  onClick={() => setPrinterType("usb")}
                >
                  USB 프린터
                </div>
                <div
                  className={`tab ${printerType === "lan" && "active"}`}
                  onClick={() => setPrinterType("lan")}
                >
                  LAN 프린터
                </div>
              </div>
              {printerType === "serial" && (
                <div className="contentWrap">
                  <div className="contentItem">
                    <h4 className="title">프린터 명</h4>
                    <input
                      className="content"
                      type="text"
                      name="id"
                      placeholder="프린터 명을 입력해 주세요."
                      value={printerName}
                      autoComplete="off"
                      onChange={onChange_printerName}
                    />
                  </div>
                  <div className="contentItem">
                    <h4 className="title">USB를 선택하세요</h4>
                    <RenderCustomSelect
                      options={serialUSBList}
                      defaultValue={serialUsb}
                      onChangeValue={onChange_serialUsb}
                    />
                  </div>
                  <div className="contentItem">
                    <h4 className="title">프린트 출력 횟수 설정</h4>
                    <div className="row content">
                      <div className="countBox">
                        <button
                          className={`${printCount === 0 && "disabled"}`}
                          onClick={() => onChange_count(printCount - 1)}
                        >
                          &#8722;
                        </button>
                        {printCount}
                        <button onClick={() => onChange_count(printCount + 1)}>
                          &#43;
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {printerType === "usb" && (
                <div className="contentWrap">
                  <div className="contentItem">
                    <h4 className="title">프린터 명</h4>
                    <input
                      className="content"
                      type="text"
                      name="id"
                      placeholder="프린터 명을 입력해 주세요."
                      value={printerName}
                      autoComplete="off"
                      onChange={onChange_printerName}
                    />
                  </div>
                  <div className="contentItem">
                    <h4 className="title">IP</h4>
                    <input
                      className="content"
                      type="text"
                      name="id"
                      placeholder="IP를 입력해주세요."
                      value={usbIp}
                      autoComplete="off"
                      onChange={onChange_usbIp}
                    />
                  </div>
                  <div className="contentItem">
                    <h4 className="title">PORT</h4>
                    <input
                      className="content"
                      type="text"
                      name="id"
                      placeholder="PORT를 입력해주세요."
                      value={usbPort}
                      autoComplete="off"
                      onChange={onChange_usbPort}
                    />
                  </div>
                  <div className="networkWrap">
                    <span>IP 주소 : </span>
                    <span>192.168.168.1</span>
                    <br />
                    <span>IP V4 주소 : </span>
                    <span>192.168.168.2</span>
                    <br />
                    <span>SSID : </span>
                    <span>throowifi</span>
                    <br />
                    <span>게이트웨이 (Gateway) : </span>
                    <span>192.168.168.0</span>
                    <br />
                  </div>
                </div>
              )}
              {printerType === "lan" && (
                <div className="contentWrap">
                  <div className="contentItem">
                    <h4 className="title">프린터 명</h4>
                    <input
                      className="content"
                      type="text"
                      name="id"
                      placeholder="프린터 명을 입력해 주세요."
                      value={printerName}
                      autoComplete="off"
                      onChange={onChange_printerName}
                    />
                  </div>
                  <div className="contentItem">
                    <h4 className="title">Port</h4>
                    <RenderCustomSelect
                      options={lanPortList}
                      defaultValue={lanPort}
                      onChangeValue={onChange_lanPort_select}
                    />
                  </div>
                  <div className="contentItem">
                    <h4 className="title">Port (직접 입력)</h4>
                    <input
                      className="content"
                      type="text"
                      name="id"
                      placeholder="PORT를 입력해주세요."
                      value={lanPort}
                      autoComplete="off"
                      onChange={onChange_lanPort}
                    />
                  </div>
                  <div className="contentItem">
                    <h4 className="title">Baud Rate</h4>
                    <RenderCustomSelect
                      options={lanBandRouteList}
                      defaultValue={lanBandRoute}
                      onChangeValue={onChange_lanBandRoute}
                    />
                  </div>
                </div>
              )}

              <div className="footer">
                <button className="testButton">프린터 테스트 하기</button>
                <button
                  onClick={() => {
                    set_sCurrentPage("list");
                  }}
                  style={{ marginRight: 20 }}
                >
                  프린터 추가하기
                </button>
                <button
                  className="submitButton"
                  onClick={() => {
                    set_sCurrentPage("list");
                  }}
                >
                  추가하기
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </Style>
  );
};

export const Style = styled.div`
  h1,
  h2,
  h3,
  h4,
  h5,
  span,
  p,
  button {
    color: #333333;
  }

  h2 {
    font-weight: 600;
  }
  .row.title {
    display: flex;
    align-items: center;
    padding-bottom: 50px;
    gap: 20px;
    cursor: pointer;
  }

  .bgWrapper {
    position: fixed;
    bottom: 0;
    height: 100vh;
    width: 100vw;
    z-index: 20;
    background: rgba(0, 0, 0, 0.6);
    left: 0;
    display: flex;
    cursor: pointer;
  }

  .printerWrapper {
    position: fixed;
    bottom: 0;
    left: 0;
    top: 0;
    right: 0;
    z-index: 22;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
  }

  .printerList {
    height: calc(100vh);
    width: calc(100vw);
    background: #fff;
    border-radius: 0;
    padding: 20px;
    z-index: 30;
    overflow: hidden;
    position: relative;
  }

  .printerScroll {
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 40px 0;

    .printerItem {
      display: flex;
      align-items: center;
      gap: 12px;
    }
    .indexBox {
      width: 22px;
      height: 22px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #ffffff;
      border: 1px solid #999999;
      border-radius: 5px;
      font-size: 14px;
      color: #333333;
    }
    .name {
      width: 160px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      font-size: 16px;
      font-weight: 600;
      color: #333333;
    }
    button {
      width: 70px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #ffffff;
      border: 1px solid #d2d2d2;
      border-radius: 5px;
      font-size: 16px;
      color: #000000;
    }
    button.test {
      margin-left: 12px;
      border: 1px solid #000000;
      width: 160px;
    }
  }

  .mainTabList {
    position: relative;
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .tab {
      flex: 1;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 600;
      border: 2px solid #d2d2d2;
      color: #999999;
      cursor: pointer;
    }
    .tab.active {
      border: 2px solid #000000;
      color: #000000;
      z-index: 1;
    }
    .tab:nth-child(1) {
      border-radius: 10px 0 0 0;
      margin-right: -1px;
    }
    .tab:nth-child(3) {
      border-radius: 0 10px 0 0;
      margin-left: -1px;
    }
  }

  .contentWrap {
    padding: 20px 0;
    .contentItem {
      padding: 14px 0;
      display: flex;
      align-items: center;
      gap: 12px;
    }
    h4 {
      font-weight: 600;
    }
    input {
      height: 34px;
      padding: 0 20px;
      border-radius: 5px;
      border: 1px solid #d2d2d2;
      font-size: 16px;
      line-height: 28px;
    }
    input::placeholder {
      font-size: 16px;
      line-height: 28px;
      color: #d2d2d2;
      font-weight: 400;
    }
    .title {
      width: 200px;
    }
    .content {
      flex: 1;
    }
    .row {
      display: flex;
      align-items: center;
    }

    .countBox {
      width: 100px;
      height: 34px;
      border-radius: 5px;
      border: 1px solid #d2d2d2;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 18px;
      color: #999999;
      button {
        padding: 0 6px;
        display: flex;
        font-size: 30px;
        line-height: 30px;
        margin-bottom: 4px;
        color: #999999;
        font-weight: 300;
      }
      button.disabled {
        color: #ececec;
      }
    }

    .networkWrap {
      padding: 10px 20px;
      border-radius: 5px;
      background: #efefef;

      span {
        font-size: 14px;
        line-height: 20px;
        color: #999999;
      }
    }
  }

  .footer {
    width: calc(100% - 140px);
    display: flex;
    flex-direction: column;
    gap: 10px;
    position: fixed;
    bottom: 100px;
  }
  .testButton {
    width: 200px;
    text-align: center;
    padding: 5px 26px;
    font-size: 16px;
    line-height: 28px;
    font-weight: 500;
    color: #333333;
    border-radius: 5px;
    border: 1px solid #d2d2d2;
  }
  .submitButton {
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    background: #000000;
    gap: 30px;
    font-size: 16px;
    font-weight: 600;
    color: #ffffff;
  }

  // select css
  .selector {
    flex: 1;
    height: 34px;
    position: relative;
    padding: 0 20px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    font-size: 14px;
    line-height: 20px;
    color: #979797;
    border: 1px solid #cecece;
    border-radius: 5px;
    cursor: pointer;
  }
  .selectHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    color: #999999;
    font-weight: 400;
  }

  .selectList {
    width: 100%;
    position: absolute;
    overflow-y: auto;
    z-index: 1;
    top: 17px;
    left: 0;
    padding: 0;
    border-radius: 0px 0px 5px 5px;
    background: #ffffff;
    border: 1px solid #cecece;
    list-style: none;

    .selectItem {
      padding: 6px 20px;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .selectItem:hover {
      background: #ecf5f3;
    }
    .selectItem.selected {
      background: #333333;
      color: #ffffff;
    }
  }
  ::-webkit-scrollbar {
    display: none;
  }
`;
